'use client';

import { type ReactNode } from 'react';
import { useCoreContext } from 'providers/core-provider';
import { EquipmentLoader } from '../equipment-loader';

type EquipmentLoaderWrapperType = {
  children: ReactNode;
};

const EquipmentLoaderWrapper = ({ children }: EquipmentLoaderWrapperType) => {
  const {
    isAddingEquipment,
    isSelectingEquipment,
    isDeletingEquipment,
    isDeselectingEquipment,
    isEditingEquipment
  } = useCoreContext();

  const shouldDisplayLoader =
    isAddingEquipment ||
    isSelectingEquipment ||
    isDeletingEquipment ||
    isDeselectingEquipment ||
    isEditingEquipment;

  return (
    <div className="position-relative">
      {shouldDisplayLoader ? (
        <EquipmentLoader>{children}</EquipmentLoader>
      ) : (
        children
      )}
    </div>
  );
};

export default EquipmentLoaderWrapper;
